export default "__VITE_ASSET__oD6KN_O5__"